<!--
  The LucentLake brand mark — a four-node graph with the emphasis node
  lower-centre.

  Byte-identical in both apps' `App.vue` before extraction. Purely decorative:
  the accessible name lives on the surrounding lockup link in `AppShell`, so
  this carries `aria-hidden` and contributes nothing to the a11y tree.

  Colours are hard-coded rather than tokenised on purpose. This is a brand
  asset: `--primary` is free to be re-themed by a future skin, and the mark
  must not follow it. It is also the one element that renders identically in
  light and dark, sitting on the header's own dark gradient in both.
-->

<template>
  <span class="lucent-mark" aria-hidden="true">
    <svg width="20" height="20" viewBox="0 0 24 24">
      <line x1="6" y1="8" x2="14" y2="6" stroke="#6aceb0" stroke-width="0.6" />
      <line x1="14" y1="6" x2="12" y2="14" stroke="#6aceb0" stroke-width="0.6" />
      <line x1="12" y1="14" x2="20" y2="18" stroke="#6aceb0" stroke-width="0.6" />
      <circle cx="6" cy="8" r="1.3" fill="#6aceb0" opacity="0.85" />
      <circle cx="14" cy="6" r="1.3" fill="#6aceb0" opacity="0.85" />
      <circle cx="12" cy="14" r="2" fill="#6aceb0" />
      <circle cx="20" cy="18" r="1.3" fill="#6aceb0" opacity="0.85" />
    </svg>
  </span>
</template>
